import { type Client, ClientApplicationStatus, ClientPlan, ClientStatus, ClientType } from '@maru44/huntre-utils/src/models/client'
import type { ClientMember } from '@maru44/huntre-utils/src/models/clientMember'
import { getData } from '@maru44/huntre-utils/src/utils/data'
import { addDoc, collection, getDocs, query, serverTimestamp, where } from 'firebase/firestore'
import { useCallback } from 'react'
import { useUser } from 'src/hooks/user/useUser'
import { firestore } from 'src/utils/firebase'
import useSWR from '../useSWR'

export const useClients = (userId: string) => {
  const { ensureCanJoinAnotherGroup } = useUser(userId)

  const listClients = useSWR(
    [`/clients`, userId],
    async () => {
      const q = query(collection(firestore, `clients`), where('clientMemberIds', 'array-contains', userId))
      const snap = await getDocs(q)

      const clients = snap.docs.map((s) => getData<Client>(s))
      return clients
    },
    {
      disabled: !userId,
    },
  )

  const createGroupClient = useCallback(
    async (input: { name: string; iconURL: string; address: string }, _currentMember: ClientMember) => {
      await ensureCanJoinAnotherGroup(userId)
      const ref = collection(firestore, `clients`)
      const now = serverTimestamp()
      await addDoc(ref, {
        ...input,
        clientMemberIds: [userId],
        ownerMemberId: userId,
        createdMemberId: userId,
        createdAt: now,
        updatedAt: now,
        status: ClientStatus.Active,
        plan: ClientPlan.Free,
        type: ClientType.Group,
        applicationStatus: ClientApplicationStatus.Approved,
      })

      // const memberRef = collection(firestore, `clients/${added.id}/clientMembers`)
      // await addDoc(memberRef, {
      //   name: currentMember.name,
      //   email: currentMember.email,
      //   phone: currentMember.phone,
      //   iconURL: currentMember.iconURL,
      //   status: ClientMemberStatus.Joined,
      //   role: ClientMemberRole.Admin,
      //   notificationMethods: [ClientMemberNotificationMethod.Email],
      //   createdAt: now,
      //   updatedAt: now,
      // })
    },
    [userId, ensureCanJoinAnotherGroup],
  )

  return { listClients, createGroupClient }
}
